/* 🤖 this file was generated by svg-to-ts */
export const IconBigBrandYoutube: {
    name: 'big-brand-youtube';
    data: string;
} = {
    name: 'big-brand-youtube',
    data: `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 40 40"><path d="M35.32 11.599a4.13 4.13 0 0 0-2.908-2.896C29.83 8 19.5 8 19.5 8S9.17 8 6.588 8.677a4.21 4.21 0 0 0-2.908 2.922C3 14.169 3 19.5 3 19.5s0 5.358.68 7.9a4.13 4.13 0 0 0 2.909 2.897C9.199 31 19.5 31 19.5 31s10.33 0 12.911-.677a4.13 4.13 0 0 0 2.91-2.895c.678-2.57.678-7.9.678-7.9s.028-5.358-.68-7.929M16.21 24.425v-9.85L24.8 19.5z"/></svg>`,
};
